import { StateCreator } from 'zustand';
import { GameState } from '../gameStore';

export interface ModelSlice {
  selectedModel: string;
  useVision: boolean;
  
  setSelectedModel: (model: string) => void;
  setUseVision: (useVision: boolean) => void;
}

export const createModelSlice: StateCreator<
  GameState,
  [],
  [],
  ModelSlice
> = (set) => ({
  selectedModel: 'gpt-4.1',
  useVision: false,
  
  setSelectedModel: (model) => set({ selectedModel: model }),
  setUseVision: (useVision) => set({ useVision }),
  setModelWithVision: (model: string, useVision: boolean) => set({ 
    selectedModel: model,
    useVision: useVision 
  }),
});